import getAndroidVersion from "../utils/getAndroidVersion";

if (process.browser) {
  require("./scroll_polyfill.js");
  const version = getAndroidVersion(window.navigator.userAgent);
  if (version && version.SYS === "android" && version.VC < 5) {
    require("./calc-polyfill.js");
  }
}
